export default __webpack_public_path__ + "static/media/home_explain_analytics.12e2159d.png";